import { useHref } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { currentCurrencySelector, sessionIdSelector, useDataRequestLang } from '../app/main-slice';
import { RootState } from '../app/store';

import styles from './dev-tools.module.css';

const userIdSelector = (state:RootState) => state.main.userId;

export function LoggedDevTools() {

    const sessionid = useAppSelector(sessionIdSelector);
    const languageid = useDataRequestLang();
    const currency = useAppSelector(currentCurrencySelector);
    const userid = useAppSelector(userIdSelector);
    const actionURL = useHref('/vk')

    return <form action={actionURL} method="get" className={styles.twoColsForm}>

        <h1>VKParameters</h1>

        <h2>Data Params</h2>
        <label>
            <span>pricelist</span>
            <input type="text" name="pricelist" />
        </label>
        <label>
            <span>jobnumber</span>
            <input type="text" name="jobnumber" />
        </label>
        <label>
            <span>model</span>
            <input type="text" name="model" />
        </label>

        <h2>Model Params</h2>
        <label>
            <span>family</span>
            <input type="text" name="family" />
        </label>
        <label>
            <span>variant</span>
            <input type="text" name="variant" />
        </label>

        <h2>Login Params</h2>
        <label>
            <span>sessionid</span>
            <input type="text" name="sessionid" defaultValue={sessionid} />
        </label>
        <label>
            <span>languageid</span>
            <input type="text" name="languageid" defaultValue={languageid} />
        </label>
        <label>
            <span>currency</span>
            <input type="text" name="currency" defaultValue={currency} />
        </label>
        <label>
            <span>userid</span>
            <input type="text" name="userid" defaultValue={userid} />
        </label>
        <label>
            <span>country</span>
            <input type="text" name="country" />
        </label>

        <button type="submit">Submit</button>

    </form>

}